import type { ReactNode } from 'react';

interface PainelIrisProps {
  titulo?: ReactNode;
  /** Linha de apoio sob o título (mock: 13px text-3). */
  descricao?: ReactNode;
  /** Conteúdo extra alinhado à direita do título (badge, ação). */
  acao?: ReactNode;
  className?: string;
  children: ReactNode;
}

/** Painel padrão Íris: surface + borda + raio 12px (mock design_handoff_sistema). */
export default function PainelIris({ titulo, descricao, acao, className = '', children }: PainelIrisProps) {
  return (
    <section className={`bg-surface border border-line rounded-iris-lg p-5 ${className}`}>
      {(titulo || acao) && (
        <div className="flex items-start justify-between gap-3 mb-4">
          <div className="min-w-0">
            {titulo && <h2 className="text-[15px] font-semibold text-tx tracking-[-0.01em]">{titulo}</h2>}
            {descricao && <p className="text-[13px] text-tx-3 mt-0.5">{descricao}</p>}
          </div>
          {acao}
        </div>
      )}
      {children}
    </section>
  );
}
